import React, { useState } from 'react';
import useAdminFetchApi from '../../utils/adminFetchApi';

export default function AdminProfileFixer() {
  const api = useAdminFetchApi();
  const [instruction, setInstruction] = useState(
    `create a realistic bio paragraph (the person is talking about himself) appropriate with the character make it as realistic as possible exactly the same way how people talk there (ex if country is malaysia make it appear like a real malaysian is talking the same casual way maybe you should include malaysian words ...)`
  );
  const [idsText, setIdsText] = useState('');
  const [fromId, setFromId] = useState('');
  const [toId, setToId] = useState('');
  const [limit, setLimit] = useState('');
  const [model, setModel] = useState('');
  const [dryRun, setDryRun] = useState(true);
  const [concurrency, setConcurrency] = useState('3');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const parseIds = (txt) => {
    if (!txt) return [];
    return txt
      .split(/[\s,]+/)
      .map(s => s.trim())
      .filter(Boolean)
      .map(n => Number(n))
      .filter(n => Number.isInteger(n) && n >= 1);
  };

  const validate = () => {
    if (!instruction.trim()) return 'Instruction is required';
    if (concurrency !== '') {
      const n = Number(concurrency);
      if (!Number.isInteger(n) || n < 1) return 'Concurrency must be an integer >= 1';
    }
    if (fromId !== '') {
      const n = Number(fromId);
      if (!Number.isInteger(n) || n < 1) return 'fromId must be an integer >= 1';
    }
    if (toId !== '') {
      const n = Number(toId);
      if (!Number.isInteger(n) || n < 1) return 'toId must be an integer >= 1';
    }
    if (fromId !== '' && toId !== '' && Number(toId) < Number(fromId)) {
      return 'toId must be >= fromId';
    }
    if (limit !== '') {
      const n = Number(limit);
      if (!Number.isInteger(n) || n < 1) return 'limit must be an integer >= 1';
    }
    // ids text is optional but if provided must parse into at least one id
    const ids = parseIds(idsText);
    if (idsText && ids.length === 0) return 'IDs must be a comma or space-separated list of integers >= 1';
    return '';
  };

  const onRun = async () => {
    setError('');
    setSuccess('');
    const v = validate();
    if (v) { setError(v); return; }

    const payload = {
      instruction: instruction.trim(),
      dryRun: !!dryRun,
    };
    const ids = parseIds(idsText);
    if (ids.length) payload.ids = ids;
    if (fromId !== '') payload.fromId = Number(fromId);
    if (toId !== '') payload.toId = Number(toId);
    if (limit !== '') payload.limit = Number(limit);
    if (model.trim()) payload.model = model.trim();
    if (concurrency !== '') payload.concurrency = Number(concurrency);

    setLoading(true);
    try {
      const resp = await api.post('/admin/profile-fixer/run', payload);
      setSuccess(resp?.message || 'Profile fixer started');
    } catch (e) {
      setError(e.message || 'Failed to start profile fixer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-section">
      <div className="panel" style={{maxWidth:'860px'}}>
        <h3>Profile Fixer</h3>
        <div className="field">
          <label>Instruction</label>
          <textarea rows={4} placeholder="Describe the fix to apply..." value={instruction} onChange={(e)=>setInstruction(e.target.value)} />
        </div>
        <div className="grid-2">
          <div className="field">
            <label>IDs (optional)</label>
            <input type="text" placeholder="e.g. 12, 34 56" value={idsText} onChange={(e)=>setIdsText(e.target.value)} />
          </div>
          <div className="field">
            <label>Model (optional)</label>
            <input type="text" placeholder="e.g. gpt-4o-mini" value={model} onChange={(e)=>setModel(e.target.value)} />
          </div>
        </div>
        <div className="grid-3" style={{gap:'12px', display:'grid', gridTemplateColumns:'1fr 1fr 1fr'}}>
          <div className="field">
            <label>From ID (optional)</label>
            <input type="number" min={1} placeholder="e.g. 1" value={fromId} onChange={(e)=>setFromId(e.target.value)} />
          </div>
          <div className="field">
            <label>To ID (optional)</label>
            <input type="number" min={1} placeholder="e.g. 1000" value={toId} onChange={(e)=>setToId(e.target.value)} />
          </div>
          <div className="field">
            <label>Limit (optional)</label>
            <input type="number" min={1} placeholder="e.g. 100" value={limit} onChange={(e)=>setLimit(e.target.value)} />
          </div>
        </div>
        <div className="grid-2" style={{gap:'12px', display:'grid', gridTemplateColumns:'1fr 1fr'}}>
          <div className="field">
            <label>Concurrency (optional)</label>
            <input type="number" min={1} placeholder="e.g. 3" value={concurrency} onChange={(e)=>setConcurrency(e.target.value)} />
          </div>
          <div className="field" style={{display:'flex', alignItems:'center'}}>
            <label style={{marginRight:8}}>Dry Run</label>
            <input type="checkbox" checked={dryRun} onChange={(e)=>setDryRun(e.target.checked)} />
          </div>
        </div>
        {error && <div className="error-message" style={{marginTop:12}}>{error}</div>}
        {success && <div className="error-message" style={{marginTop:12, background:'#133021', color:'#bbf7d0', borderColor:'#14532d'}}>{success}</div>}
        <div style={{marginTop:12, display:'flex', gap:8}}>
          <button className="button primary" onClick={onRun} disabled={loading}>{loading ? 'Running…' : 'Run fixer'}</button>
        </div>
      </div>
    </div>
  );
}
